var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2",
    fill: "#6C7180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08469 6.65039V6.66039C7.65369 6.66039 7.30469 7.01039 7.30469 7.44039C7.30469 7.87039 7.65369 8.22039 8.08469 8.22039H11.0737C11.5047 8.22039 11.8547 7.87039 11.8547 7.42939C11.8547 7.00039 11.5047 6.65039 11.0737 6.65039H8.08469ZM15.9247 12.7407H8.08469C7.65369 12.7407 7.30469 12.3907 7.30469 11.9607C7.30469 11.5307 7.65369 11.1797 8.08469 11.1797H15.9247C16.3547 11.1797 16.7047 11.5307 16.7047 11.9607C16.7047 12.3907 16.3547 12.7407 15.9247 12.7407ZM15.9209 17.3103H8.08094C7.78094 17.3503 7.49094 17.2003 7.33094 16.9503C7.17094 16.6903 7.17094 16.3603 7.33094 16.1103C7.49094 15.8503 7.78094 15.7103 8.08094 15.7403H15.9209C16.3199 15.7803 16.6209 16.1203 16.6209 16.5303C16.6209 16.9293 16.3199 17.2703 15.9209 17.3103Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.cfc50b8871a83778facc920b141e70c6.svg";
export { ForwardRef as ReactComponent };